<template>
	<div>
		<Modal
			:show="showModal"
			@close="closeModal"
			body-classes="m-0 pt-0 pb-0"
			:hideFooter="true"
			footer-classes="pt-0"
			header-classes="pb-1"
			size="lg"
		>
			<template v-slot:header>
				<h5 class="modal-title" id="modalTitle">{{ headerTitle }}</h5>
			</template>

			<b-overlay :show="isLoading" rounded="sm">
				<div class="pt-2">
					<h5 v-if="editSpeakerData == null" style="flex: auto; text-align: center">
						Upload a new speaker to the app.
					</h5>
					<h6 v-if="errorMessage" style="color: red; flex: auto; text-align: center">
						{{ errorMessage }}
					</h6>
				</div>

				<form ref="form" class="pt-1 pb-1">
					<VueDropZone
						v-if="editSpeakerData == null"
						class="p-0 m-0"
						id="logo"
						style="border: 0; z-index: 1"
						v-on:vdropzone-files-added="addedImage"
						:options="dropzoneOptions"
					>
					</VueDropZone>
					<div class="py-3" v-else>
						<label class="form-control-label">
							Speaker Photo
						</label>
					<b-row>
						<b-col
							cols="auto"
							@mouseover="imageHover = true"
							@mouseleave="imageHover = false"
						>
					<div class="b-img-helpers card-img ">
						<div
							style="height: 100px; width: 100px; overflow: hidden"
							:style="{ opacity: imageHover ? 0.4 : 1 }"
						>
							<b-img-lazy
								:src="speakerData.speakerPhoto"
								rounded="circle"
								class="avatar mr-2"
								style="height: 100px; width: 100px; object-fit: cover;"
							/>
						</div>
						<div
							v-if="imageHover"
							style="
								height: 100%;
								width: 100%;
								border: dashed 1px black;
								display: flex;
								flex-wrap: wrap;
								align-content: center;
							"
							class="justify-content-center b-img-base"
						>
							<BaseButton type="primary" size="sm" block @click="showChangeImageModal = true"
								>Edit</BaseButton
							>
						</div>
					</div>
				</b-col>
					</b-row>
					</div>

					<BaseInput
						label="Speaker Name"
						id="speaker name"
						placeholder="Speaker Name"
						required
						v-model="speakerData.speakerName"
					/>
					<BaseInput label="Speaker Bio">
						<textarea
							placeholder="Enter speaker bio..."
							v-model="speakerData.speakerBio"
							class="form-control"
							id="speaker description"
							rows="6"
							required
						></textarea>
					</BaseInput>

					<ButtonRadioGroup v-if="dataSets"
						label="Select Event"
						:options="dataSets"
						v-model="speakerData.dataSet"/>

					<b-row class="mr-0 mt-3 mb-3">
						<div style="flex-grow: 1"></div>
						<base-button
							type="primary"
							:loading="isLoading"
							:shake="shake"
							@click="submit"
							>{{ editSpeakerData == null ? 'Add Speaker' : 'Update Speaker'}}</base-button
						>
					</b-row>
				</form>
			</b-overlay>
		</Modal>
		<ChangeImage
			:showModal="showChangeImageModal"
			@updatedImage="updateImage"
			@close="showChangeImageModal = false"
		/>
	</div>
</template>
<script>
import { collection, doc, setDoc } from '@firebase/firestore';
import {
	uploadBytes,
	getDownloadURL,
	ref as firebaseStorageRef,
} from 'firebase/storage';
import VueDropZone from 'vue2-dropzone';
import ButtonRadioGroup from '../../components/ButtonRadioGroup.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { mapGetters } from 'vuex';
import BaseInput from '../../components/Inputs/BaseInput.vue';
import Modal from '../../components/Modals/Modal.vue';
import {
	getOrganizationFirestore,
	getOrganizationStorage,
} from '../../resources/organizationFirebase';
import ChangeImage from './ChangeImage.vue';
import BaseButton from '../../components/BaseButton.vue';

export default {
	components: { Modal, BaseInput, VueDropZone, BaseButton, ChangeImage, ButtonRadioGroup },
	computed: {
		...mapGetters({
			organization: 'getOrganization',
			dataSets: 'getDataSets'
		}),
	},
	props: {
		headerTitle: {
			type: String,
			default: 'New Speaker',
		},
		showModal: {
			type: Boolean,
			default: false,
		},
		editSpeakerData: {
			type: Object,
			default: null,
		},
	},
	watch: {
		editSpeakerData: {
			handler(val) {
				if (val) {
					this.speakerData.speakerName = val.speakerName;
					this.speakerData.speakerBio = val.speakerBio;
					this.speakerData.speakerPhoto = val.speakerPhoto;
					return;
				} else {
					return this.resetView();
				}
			},
			deep: true,
		},
	},
	data() {
		return {
			shake: false,
			isLoading: false,
			imageHover: false,
			showChangeImageModal: false,
			speakerData: {
				speakerName: null,
				speakerBio: null,
				speakerPhoto: null,
				dataSet: null,
			},
			updatedImage: null,
			errorMessage: null,
			dropzoneOptions: {
				url: 'https://httpbin.org/post',
				thumbnailWidth: 100,
				height: 100,
				addRemoveLinks: true,
				acceptedFiles: 'image/*',
				dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> UPLOAD ME",
			},
		};
	},
	methods: {
		resetView() {
			this.speakerData.speakerPhoto = null;
			this.speakerData.speakerName = null;
			this.speakerData.speakerBio = null;
			this.speakerData.dataSet = null;
		},
		addedImage(file) {
			this.speakerData.speakerPhoto = file;
		},
		updateImage(file) {
			this.updatedImage = file[0];
			this.speakerData.speakerPhoto = this.updatedImage.dataURL
			console.log(file[0].dataURL)
		},
		closeModal() {
			this.$emit('update:show', false);
			this.$emit('close');
		},
		submit() {
			this.shake = false;

			const speakerPhoto = this.speakerData.speakerPhoto;
			const speakerName = this.speakerData.speakerName;
			const speakerBio = this.speakerData.speakerBio;

			const dataSet = this.speakerData.dataSet;

			if (this.editSpeakerData == null && speakerPhoto == null) {
				this.errorMessage = "Please add this speaker's profile picture.";
				this.shake = true;
				return;
			} else if (
				this.$helpers.isBlank(speakerName) ||
				this.$helpers.isBlank(speakerBio)
			) {
				this.errorMessage = 'Please complete all the necessary fields.';
				this.shake = true;
				return;
			} else if (this.dataSets && this.$helpers.isBlank(dataSet)){
				this.errorMessage = 'Please select a conference.';
				this.shake = true;
				return;
			} else {
				this.errorMessage = null;

				const storage = getOrganizationStorage(this.organization);
				const firestore = getOrganizationFirestore(this.organization);
				const speakerRef = collection(firestore, 'speakers');

				var speakerIdRef = null;

				if (this.editSpeakerData != null) {
					speakerIdRef = doc(
						firestore,
						`${speakerRef.path}/${this.editSpeakerData.speakerId}`
					);
					if (this.updatedImage){
						const storageRef = firebaseStorageRef(
							storage,
							`speakers/${speakerIdRef.id}`
						);
						this.uploadImage(storageRef, speakerIdRef, this.updatedImage);
					} else {
						this.sendSpeakerToFirebase(null, speakerIdRef);
					}
				} else {
					speakerIdRef = doc(speakerRef);
					const storageRef = firebaseStorageRef(
						storage,
						`speakers/${speakerIdRef.id}`
					);
					this.uploadImage(storageRef, speakerIdRef, this.speakerData.speakerPhoto[0]);
				}



				this.isLoading = true;
			}
		},
		uploadImage(storageRef, speakerIdRef, imageFile) {
			const metadata = {
				contentType: 'image/jpg',
			};

			uploadBytes(storageRef, imageFile, metadata)
				.then((result) => {
					const resultRef = result.ref;
					getDownloadURL(resultRef).then((downloadURL) => {
						this.sendSpeakerToFirebase(downloadURL, speakerIdRef);
					});
				})
				.catch((error) => {
					//error uploading
					this.isLoading = false;
					this.errorMessage = error.message;
					this.shake = true;
				});
		},
		sendSpeakerToFirebase(imageURL, speakerIdRef) {
			const speakerId = speakerIdRef.id;
			var speakerInfo = {
				speakerId: speakerId,
				speakerBio: this.speakerData.speakerBio,
				speakerName: this.speakerData.speakerName,
			};

			if (this.speakerData.dataSet){
				speakerInfo['dataSet'] = this.speakerData.dataSet
			}

			if (imageURL) {
				speakerInfo['speakerPhoto'] = imageURL;
			}

			setDoc(speakerIdRef, speakerInfo, { merge: true })
				.then(() => {
					this.isLoading = false;
					this.$emit('newSpeaker', speakerInfo);

					this.closeModal();
					this.resetView();
				})
				.catch((error) => {
					this.isLoading = false;
					this.errorMessage = error.message;
					this.shake = true;
				});
		},
		isEmpty(str) {
			return this.$helpers.isBlank(str);
		},
	},
};
</script>
